import React from "react"
import { Segmented } from "antd"

import { ProjectView } from "features/Projects/utils/projectListState"

interface ProjectViewSwitchProps {
  value: ProjectView
  onChange: (v: ProjectView) => void
  isAdmin: boolean
}

/**
 * The project list's view switch: Owned / Member / All / Archived. "All" is
 * only offered to admins (as the old "View All Projects" button was).
 */
const ProjectViewSwitch: React.FC<ProjectViewSwitchProps> = ({
  value,
  onChange,
  isAdmin,
}) => {
  const options: { label: string; value: ProjectView }[] = [
    { label: "Owned", value: "owned" },
    { label: "Member", value: "member" },
    ...(isAdmin ? [{ label: "All", value: "all" as const }] : []),
    { label: "Archived", value: "archived" },
  ]

  return (
    <Segmented<ProjectView>
      aria-label="Projects view"
      options={options}
      value={value}
      onChange={onChange}
    />
  )
}

export default ProjectViewSwitch
